import React from "react";

const Shift = ({ height, style }) => (
  <svg
    height={height}
    style={style}
    viewBox="0 0 105 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2136_23156)">
      <g filter="url(#filter1_d_2136_23156)">
        <rect
          x="4"
          y="0.589355"
          width="96.1481"
          height="59"
          rx="7.18683"
          fill="#EFF1F5"
        />
        <rect
          x="4.62885"
          y="1.2182"
          width="94.8904"
          height="57.7423"
          rx="6.55798"
          stroke="#212326"
          strokeWidth="1.2577"
        />
      </g>
      <path
        d="M25.5744 32.2689C24.5852 32.2689 23.749 32.1108 23.0658 31.7947C22.3927 31.4786 21.8778 31.0452 21.5208 30.4945C21.1639 29.9337 20.9855 29.3014 20.9855 28.5978H23.1117C23.1117 28.8935 23.1932 29.1841 23.3564 29.4697C23.5196 29.745 23.7796 29.9694 24.1365 30.1427C24.5036 30.3161 24.9829 30.4028 25.5744 30.4028C26.1046 30.4028 26.5482 30.3263 26.9051 30.1733C27.2621 30.0203 27.5272 29.8215 27.7005 29.5768C27.8739 29.3218 27.9606 29.0363 27.9606 28.7202C27.9606 28.3225 27.7923 28.0063 27.4558 27.7718C27.1193 27.527 26.5992 27.3741 25.8956 27.3129L24.9166 27.2364C23.8459 27.1446 22.9893 26.8132 22.3468 26.2422C21.7146 25.6609 21.3985 24.8961 21.3985 23.9477C21.3985 23.2339 21.5667 22.622 21.9032 22.1122C22.2398 21.5921 22.7089 21.1944 23.3105 20.919C23.9224 20.6335 24.6362 20.4908 25.452 20.4908C26.2984 20.4908 27.0275 20.6386 27.6394 20.9343C28.2512 21.2301 28.7254 21.6482 29.0619 22.1886C29.3984 22.7189 29.5667 23.3461 29.5667 24.0701H27.4405C27.4405 23.7642 27.364 23.4837 27.2111 23.2288C27.0683 22.9637 26.8491 22.7546 26.5533 22.6016C26.2678 22.4385 25.9007 22.3569 25.452 22.3569C25.0237 22.3569 24.6668 22.4283 24.3812 22.571C24.0957 22.7138 23.8816 22.9076 23.7388 23.1523C23.596 23.397 23.5247 23.6622 23.5247 23.9477C23.5247 24.2944 23.6521 24.6004 23.9071 24.8655C24.162 25.1204 24.5648 25.2683 25.1155 25.3091L26.0944 25.4009C26.8898 25.462 27.5884 25.6303 28.19 25.9056C28.7917 26.181 29.2557 26.5532 29.582 27.0223C29.9185 27.4914 30.0868 28.0573 30.0868 28.7202C30.0868 29.4238 29.9032 30.0458 29.5361 30.5863C29.169 31.1166 28.6438 31.5296 27.9606 31.8253C27.2875 32.121 26.4921 32.2689 25.5744 32.2689ZM31.9044 31.9783V20.812H34.0306V27.3282H33.6635C33.6635 26.492 33.7705 25.7833 33.9847 25.202C34.1988 24.6208 34.515 24.1772 34.9331 23.8712C35.3614 23.5653 35.9018 23.4123 36.5545 23.4123H36.6463C37.5946 23.4123 38.3135 23.7387 38.803 24.3913C39.2925 25.044 39.5372 25.9923 39.5372 27.2364V31.9783H37.4111V27.0376C37.4111 26.5073 37.2581 26.0892 36.9522 25.7833C36.6564 25.4773 36.2638 25.3244 35.7744 25.3244C35.2543 25.3244 34.8311 25.4977 34.5048 25.8445C34.1886 26.181 34.0306 26.6246 34.0306 27.1752V31.9783H31.9044ZM42.2208 31.9783V23.6724H44.347V31.9783H42.2208ZM41.0583 25.2632V23.6724H44.347V25.2632H41.0583ZM43.0009 22.6781C42.5828 22.6781 42.2718 22.571 42.0678 22.3569C41.8741 22.1326 41.7772 21.8572 41.7772 21.5309C41.7772 21.1842 41.8741 20.9038 42.0678 20.6896C42.2718 20.4755 42.5828 20.3684 43.0009 20.3684C43.419 20.3684 43.7249 20.4755 43.9187 20.6896C44.1124 20.9038 44.2093 21.1842 44.2093 21.5309C44.2093 21.8572 44.1124 22.1326 43.9187 22.3569C43.7249 22.571 43.419 22.6781 43.0009 22.6781ZM46.9962 31.9783V23.4735C46.9962 22.5252 47.2563 21.8266 47.7763 21.3779C48.3066 20.919 49.0867 20.6896 50.1167 20.6896H51.1568V22.3263H49.9637C49.6476 22.3263 49.4028 22.413 49.2295 22.5863C49.0663 22.7495 48.9847 22.984 48.9847 23.29V31.9783H46.9962ZM45.9561 25.3703V23.81H51.2945V25.3703H45.9561ZM56.3824 32.0853C55.6176 32.0853 54.9854 31.9885 54.4857 31.7947C53.9962 31.5908 53.6291 31.2542 53.3843 30.7852C53.1396 30.3059 53.0172 29.6634 53.0172 28.8578L53.0325 21.332H55.021L55.0057 28.9955C55.0057 29.4034 55.1128 29.7195 55.327 29.9439C55.5513 30.158 55.8674 30.2651 56.2753 30.2651H57.5755V32.0853H56.3824ZM51.7017 25.2326V23.6724H57.5755V25.2326H51.7017Z"
        fill="#42464C"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2136_23156"
        x="0"
        y="0.589355"
        width="104.148"
        height="67"
        filterUnits="userSpaceOnUse"
        colorInterpolationfilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2136_23156"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2136_23156"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_2136_23156"
        x="1.88037"
        y="0.589355"
        width="98.2678"
        height="63.3704"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.11963" dy="4.37037" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.27451 0 0 0 0 0.298039 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2136_23156"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2136_23156"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default Shift;
